import styled from 'styled-components';
import { colors } from 'bench-style-constants';

// TODO: This is a temporary button.
// This should be replaced with the primitive component package in the future.

export default styled.button`
  position: relative;
  box-sizing: border-box;
  padding: ${({ large }) => (large ? '12px' : '8px')} 24px;
  background: ${({ ghost, totalGhost }) => (ghost || totalGhost ? 'transparent' : colors.water)};
  color: ${({ ghost, totalGhost }) => (ghost || totalGhost ? colors.charcoal : colors.white)};
  border-radius: 3px;
  outline: 0;
  cursor: pointer;
  transition: background-color 0.2s ease-out;
  font-size: 12px;
  line-height: 1;
  text-shadow: none;
  text-transform: uppercase;
  border: ${({ ghost, totalGhost }) =>
    totalGhost ? '1px solid transparent' : `1px solid ${ghost ? colors.stone : colors.water}`};

  &:active {
    box-shadow: none;
  }

  &:hover {
    background: transparent;
    color: ${colors.water};
  }

  &:disabled {
    background: ${colors.cloud};
    border-color: ${colors.cloud};
    &:hover {
      color: ${colors.white};
    }
  }

  ${({ ghost, totalGhost }) =>
    (totalGhost || ghost) &&
    `
    &:hover {
      color: ${colors.stone};
    }
  `};
`;
